export const USER_LAYOUT_RECT_LEVEL = 9;
export const DEFAULT_LAYOUT_RECT_LEVEL = 0;
export const DEFAULT_LAYOUT_RECT_LEVEL_MIN = -1;

export enum LayoutZIndex {
  SeriesGroup = 0,

  Axis_Grid = 50,
  CrossHair_Grid = 100,
  Region = 450,

  Mark = 300,

  Node = 400,

  Axis = 100,

  MarkLine = 500,

  MarkArea = 100,

  MarkPoint = 500,

  DataZoom = 500,

  ScrollBar = 500,

  Player = 500,

  Legend = 500,

  CrossHair = 500,

  Indicator = 500,

  Title = 500,

  Label = 500,

  Brush = 500,

  CustomMark = 500,

  Interaction = 700
}
/**
 * 数值越大，越先布局
 */
export enum LayoutLevel {
  Indicator = 10,

  Region = 20,

  Axis = 30,

  DataZoom = 40,

  Player = 40,

  ScrollBar = 40,

  Legend = 50,

  Title = 70,

  CustomMark = 70
}
